import React from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import "./styles.scss";

import gdpr_candidates from "../../files/gdpr/GDPR_candidates.pdf";
import gdpr_clients from "../../files/gdpr/GDPR_clients.pdf";
import gdpr_form from "../../files/gdpr/GDPR_form.odt";
import gdpr_data_processing from "../../files/gdpr/GDPR_data_processing_notice.pdf";

import cookies from "../../files/general/cookies_policy.pdf";
import license from "../../files/general/license_2021.pdf";
import info325 from "../../files/general/info_325.pdf";
import protocol from "../../files/general/dvustranen.pdf";
import protocolManual from "../../files/general/dvustranen_ukazaniq.pdf";
import complaintPolicy from "../../files/general/complaint_policy.pdf";
import euro_acceptance from "../../files/general/euro_accept_info.pdf";
import ToS from "../../files/general/ToS.pdf";
import privacyPolicy from "../../files/general/privacypolicy.pdf";

import ZZLP1 from "../../files/zzlp/podavane_signal_narushenie.pdf";
import ZZLP2 from "../../files/zzlp/registrirane_narushenie.pdf";

const offDocs = [
  {
    name: "Уведомление за Поверителност за кандидати за Работа",
    url: gdpr_candidates,
  },
  {
    name: "Уведомление за Поверителност за Клиентите",
    url: gdpr_clients,
  },
  {
    name: "Уведомление за обработване на лични данни",
    url: gdpr_data_processing,
  },
  {
    name: "Заявление за упражняване на права по чл.15-22 от Регламент (ЕС) 2016/679",
    url: gdpr_form,
    download: "Заявление за упражняване на права по чл.15-22 от Регламент (ЕС) 2016-679.odt",
  },
];

const mainDocs = [
  {
    name: "Политика за бисквитките",
    url: cookies,
  },
  {
    name: "Лиценз",
    url: license,
  },
  {
    name: "Общи условия за ползване",
    url: ToS,
  },
  {
    name: "Политика за поверителност",
    url: privacyPolicy,
  },
  {
    name: "Информация по чл.325 от КЗ",
    url: info325,
  },
  {
    name: "Съобщение към потребителите за приемане на еврото",
    url: euro_acceptance,
  },
  {
    name: "Двустранен констативен протокол",
    url: protocol,
  },
  {
    name: "Указания за попълване на Двустранен констативен протокол",
    url: protocolManual,
  },
  {
    name: "Политика за жалбите",
    url: complaintPolicy,
  },
];

const thirdSection = [
  {
    name: "Подаване на сигнали за нарушение",
    url: ZZLP1,
  },
  {
    name: "Формуляр за регистриране на сигнал",
    url: ZZLP2,
  },
];

const Documents = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="documents">
      <div className="documents-container">
        <div className="left-documents-container" style={{ width: "29%" }}>
          <div className="main-documents">ОСНОВНИ ДОКУМЕНТИ</div>
          <div className="documents-list">
            {mainDocs.map((doc, index) => {
              return (
                <a className="doc-container" key={index} href={doc.url} target="_blank" rel="noopener noreferrer">
                  <h4 className="doc-name">{doc.name}</h4>
                  <div className="arrowTab selectedBlue"></div>
                </a>
              );
            })}
          </div>
        </div>
        <div className="left-documents-container" style={{ marginLeft: "4%", width: "29%" }}>
          <div className="main-documents">GDPR ДОКУМЕНТИ</div>
          <div className="documents-list">
            {offDocs.map((doc, index) => {
              return (
                <a className="doc-container" key={index} href={doc.url} target="_blank" rel="noopener noreferrer" download={doc.download}>
                  <h4 className="doc-name">{doc.name}</h4>
                  <div className="arrowTab selectedBlue"></div>
                </a>
              );
            })}
          </div>
        </div>
        <div className="left-documents-container" style={{ marginLeft: "4%", width: "29%" }}>
          <div className="main-documents">ЗЗЛПСПОИН</div>
          <div className="documents-list">
            {thirdSection.map((doc, index) => {
              return (
                <a className="doc-container" key={index} href={doc.url} target="_blank" rel="noopener noreferrer">
                  <h4 className="doc-name">{doc.name}</h4>
                  <div className="arrowTab selectedBlue"></div>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect()(Documents);
